/* eslint-disable @typescript-eslint/no-non-null-assertion */
import './styles/main.css';
import './styles/colors.css';

import './util/polyfill';

import { initializeSentry } from './util/sentry';
import { initializeVersionCheck } from './util/versionCheck';
import { disableHoverOnTouch } from './util/disableHover';
import App from './App.svelte';
import { initializeSnowPlowTracker } from './util/snowplow';

initializeSentry();
initializeSnowPlowTracker();
initializeVersionCheck();
disableHoverOnTouch();

const initializeApp = () => {
  return new App({
    target: document.getElementById('app')!,
  });
};

const app = initializeApp();
export default app;
